import { gameSummary } from './gameSummary';

/** The ways to sort the games list; the first is the default. */
export const SORTS = [
  { key: 'waiting', label: 'Waiting on you' },
  { key: 'played', label: 'Last played' },
  { key: 'started', label: 'Started' },
  { key: 'opponent', label: 'Opponent' },
  { key: 'turn', label: 'Whose turn' },
  { key: 'prizes', label: 'Closest to the end' },
];

const newestFirst = (field) => (a, b) => (b.get(field) || '').localeCompare(a.get(field) || '');
const lastPlayed = newestFirst('updated_at');
/** Sorting puts `first` games before the rest, keeping the order within each. */
const firstWhen = (first) => (a, b) => Number(first(b)) - Number(first(a));
const then = (...orders) => (a, b) => orders.reduce((result, order) => result || order(a, b), 0);

/** The fewest prize cards either player still has (`prizes` lists their spots): the game ends when someone takes their last. */
const prizesLeft = (game) => {
  const board = game.get('board');
  return board && board.size ? Math.min(...board.map(side => side.get('prizes').size).toArray()) : Infinity;
};

/**
 * The games list, split into games still going and finished ones (newest first), the going ones in the chosen
 * order. Ties fall back to the most recently played.
 *
 * @returns {{ going: List, finished: List }}
 */
export function sortGames(games, sortKey, userId) {
  const opponentName = (game) => gameSummary(game, userId).against;
  const orders = {
    waiting: firstWhen(game => !!game.get('waiting_on_you')),
    played: lastPlayed,
    started: newestFirst('created_at'),
    opponent: (a, b) => opponentName(a).localeCompare(opponentName(b)),
    turn: then(firstWhen(game => game.get('active_player_id') === userId), firstWhen(game => !!game.get('active_player_id'))),
    prizes: (a, b) => prizesLeft(a) - prizesLeft(b),
  };
  const order = then(orders[sortKey] || orders.waiting, lastPlayed);

  return {
    going: games.filter(game => !game.get('ended_at')).sort(order),
    finished: games.filter(game => game.get('ended_at')).sort(newestFirst('ended_at')),
  };
}
